import React from "react";
import { useActionRight } from "../hooks/useActionRight";

/**
 * Renders action button when visible; passes disabled when action is Disable (1)
 * or page-level rules block interaction.
 */
const ActionPermissionGate = ({
  entity,
  action,
  requireFullAccess = true,
  children,
}) => {
  const { isActionVisible, isActionEnabled } = useActionRight();

  if (!isActionVisible(entity, action)) return null;

  const enabled = isActionEnabled(entity, action, { requireFullAccess });
  const child = React.Children.only(children);

  return React.cloneElement(child, {
    disabled: Boolean(child.props.disabled) || !enabled,
  });
};

export default ActionPermissionGate;
